import { Project, FilterOption, SortOption } from "../types/dashboard.types";

const lower = (v: unknown) => String(v ?? "").toLowerCase();

export const filterProjects = (
  projects: Project[] = [],
  searchQuery: string = "",
  filterStatus: FilterOption,
  sortBy: SortOption
): Project[] => {
  let filtered = projects;

  const query = lower(searchQuery).trim();
  if (query) {
    filtered = filtered.filter((p) => {
      const projectName = lower(p?.projectName);
      const slug = lower(p?.slug);
      const templateId = lower(p?.templateId);

      return (
        projectName.includes(query) ||
        slug.includes(query) ||
        templateId.includes(query)
      );
    });
  }

  if (filterStatus !== "all") {
    filtered = filtered.filter((p) => lower(p?.status) === lower(filterStatus));
  }

  return [...filtered].sort((a, b) => {
    switch (sortBy) {
      case "lastUpdated":
        return new Date(b?.updatedAt ?? 0).getTime() - new Date(a?.updatedAt ?? 0).getTime();
      case "createdDate":
        return new Date(b?.createdAt ?? 0).getTime() - new Date(a?.createdAt ?? 0).getTime();
      case "name":
        return String(a?.projectName ?? "").localeCompare(String(b?.projectName ?? ""));
      default:
        return 0;
    }
  });
};

export const getMatchingCount = (
  projects: Project[] = [],
  searchQuery: string = "",
  filterStatus: FilterOption
): number => {
  const query = lower(searchQuery).trim();

  let filtered = projects;

  if (query) {
    filtered = filtered.filter((p) => {
      const projectName = lower(p?.projectName);
      const slug = lower(p?.slug);
      const templateId = lower(p?.templateId);

      return (
        projectName.includes(query) ||
        slug.includes(query) ||
        templateId.includes(query)
      );
    });
  }

  if (filterStatus !== "all") {
    filtered = filtered.filter((p) => lower(p?.status) === lower(filterStatus));
  }

  return filtered.length;
};